import React from 'react';
import { Page, Text, View } from '@react-pdf/renderer';
import { formatDate, styles } from './pdfShared';
import { ReportPdfLogo } from './ReportPdfLogo';
import { formatDecimal } from '../../../utils/format';
import type { InventoryTrackingEvent } from '../../../services/report.service';
import type { TFn } from '../export/context';

interface InventoryRow {
  itemId: string;
  itemCode: string;
  itemName: string;
}

interface Props {
  rows: ReadonlyArray<InventoryRow>;
  tracking: Map<string, InventoryTrackingEvent[]>;
  t: TFn;
}

export const InventoryTrackingPages: React.FC<Props> = ({ rows, tracking, t }) => {
  const withTracking = rows.filter((r) => (tracking.get(r.itemId)?.length ?? 0) > 0);
  return (
    <>
      {withTracking.map((row) => {
        const events = tracking.get(row.itemId) ?? [];
        return (
          <Page key={row.itemId} size="A4" style={styles.page}>
            <ReportPdfLogo />
            <Text style={styles.title}>{row.itemName}</Text>
            <Text style={styles.subtitle}>{row.itemCode} · {t('reports.tracking.title')}</Text>
            <View style={styles.table}>
              <View style={[styles.row, styles.headerRow]}>
                <Text style={[styles.cell, styles.headText, { flexGrow: 14 }]}>{t('reports.tracking.table.date')}</Text>
                <Text style={[styles.cell, styles.headText, { flexGrow: 12 }]}>{t('reports.tracking.table.direction')}</Text>
                <Text style={[styles.cell, styles.headText, { flexGrow: 26 }]}>{t('reports.tracking.table.reference')}</Text>
                <Text style={[styles.cell, styles.headText, { flexGrow: 24 }]}>{t('reports.tracking.table.counterparty')}</Text>
                <Text style={[styles.cell, styles.headText, { flexGrow: 12 }]}>{t('reports.tracking.table.lot')}</Text>
                <Text style={[styles.cell, styles.headText, styles.right, { flexGrow: 12 }]}>{t('reports.tracking.table.quantity')}</Text>
              </View>
              {events.map((e, i) => (
                <View key={i} style={styles.row}>
                  <Text style={[styles.cell, { flexGrow: 14 }]}>{formatDate(e.date)}</Text>
                  <Text style={[styles.cell, { flexGrow: 12 }]}>{e.direction === 'in' ? t('reports.tracking.directionIn') : t('reports.tracking.directionOut')}</Text>
                  <Text style={[styles.cell, { flexGrow: 26 }]}>{e.referenceLabel}</Text>
                  <Text style={[styles.cell, { flexGrow: 24 }]}>{e.counterparty}</Text>
                  <Text style={[styles.cell, { flexGrow: 12 }]}>{e.lotNumber || '-'}</Text>
                  <Text style={[styles.cell, styles.right, { flexGrow: 12 }]}>{formatDecimal(e.quantity, 2)} {e.unit}</Text>
                </View>
              ))}
            </View>
          </Page>
        );
      })}
    </>
  );
};
